<template>
  <div class="expert-list">
    <!--导航-->
    <div class="dk-nav">
      <nav-bar title="贷款专家" url="/home" />
    </div>

    <!--贷款专家列表-->
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
    <div>
      <template v-if="loading">
      <template v-if="expert.data">
      <div class="van-card" v-for="item in filterBy(expert.data,city)">
        <div class="van-card__header">
          <a class="van-card__thumb">
            <div class="van-image" style="width: 100%; height: 100%;">
              <img :src="uploadsUrl+item.pictrue" class="van-image__img" style="object-fit: cover;">
            </div>
          </a>
          <div class="van-card__content">
            <van-row>
              <van-col span="12">
                <div>
                  <div class="van-card__title van-multi-ellipsis--l2">{{item.title}}</div>
                  <div class="van-card__desc van-ellipsis">{{item.description}}</div>
                  <div class="van-card__desc van-ellipsis">咨询量：<span style="color:#f60;">{{item.chengjiaoling}}个</span></div>
                  <div class="van-card__desc van-ellipsis">从业经验：<span style="color:#f60;">{{item.congyejingyan}}年</span></div>
                </div>
              </van-col>
              <van-col span="12" style="text-align: right;">
                <div style="height: 10px;"></div>
                <button class="van-button van-button--default van-button--small" style="background-color: #9bd3f4; color: #fff;" @click="getTel(item.phone)">
                  <div class="van-button__content">
                    <span class="van-button__text">电话咨询</span>
                  </div>
                </button>
                <div style="height: 10px;"></div>
                <button class="van-button van-button--default van-button--small" style="background-color: #00a13a; color: #fff;" @click="getGo()">
                  <div class="van-button__content">
                    <span class="van-button__text">在线咨询</span>
                  </div>
                </button>
              </van-col>
            </van-row>
          </div>
        </div>
        <div class="van-card__footer"></div>
      </div>
      </template>
      </template>
      <template v-else>
        <van-loading type="spinner" color="#ff8917" vertical />
      </template>
    </div>
    </van-pull-refresh>

  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'
import NavBar from '../../components/NavBar.vue'
export default {
    'name': 'ExpertList',
    data() {
        return {
          isLoading: false,
          loading: false
        };
    },
    computed: {
        ...mapState({
            city: state => state.cityData.city,
            expert: state => state.expert.expert_list
        })
    },
    methods: {
      ...mapActions(['requestExpert']),
        goUrl(val) {
            return this.$router.push({path: val})
        },
        onClickLeft() {
            this.$router.push({path: '/'});
        },
        filterBy(list,value){
            return list.filter(function(lists){
                  if(value == "重庆") {
                    return lists.city.match('市辖区');
                  }else{
                    return lists.city.match(value);
                  }
            })
        },
        getTel(val) {
           return window.location.href = 'tel:'+val
        },
        getGo() {
           return window.location.href="http://www.dai12345.com/kf.html";
        },
        onRefresh() {
          setTimeout(() => {
            this.isLoading = false;
          }, 1000);
        }
    },
    components: {
      NavBar
    },
    mounted() {
      this.requestExpert({"thit":this,"city":this.city});
    },
    beforeCreate() {
        this.uploadsUrl = 'https://a.chengdai.cn/uploads/'
    }
};
</script>

<style scoped>
.home >>> .van-grid-item__icon {
  font-size: 1.3rem;
}

/*导航*/
.dk-nav {
  width: 100%;
  height: 52px;
}
.expert-list >>> .van-nav-bar {
  z-index: 9;
  background-color: #ff8917;
  padding-top: 6px;
}
.expert-list >>> .van-nav-bar__text {
  color: #fff;
}
.expert-list >>> .van-nav-bar__title {
  color: #fff;
}
.expert-list >>> .van-card__thumb img {
  border-radius: 0.1rem;
}
.expert-list >>> .van-nav-bar .van-icon {
  color: #fff;
}
.expert-list >>> .van-button--info {
    color: #fff;
    background-color: #ff8917;
    border: 0.02667rem solid #ff8917;
}
</style>
